import Link from 'next/link';
import { StyledEmailVerificationContent } from './styles';
import { genericEventHandler } from '@/analytics/events';
import { GlobalEvents } from '@/analytics/events/constants';
import StringAccessor from '@/components/cmsConfig/stringAccessor';
import { ROUTES } from '@/constants/routes';

interface Props {
  referrer: string;
}

export const EmailVerification = (props: Props) => {
  const { referrer } = props;

  return (
    <div>
      <StyledEmailVerificationContent>
        <StringAccessor tag="h1" accessor="signup.email_verification_header" />

        <StringAccessor tag="p" accessor="signup.email_verification_text" html={true} />
      </StyledEmailVerificationContent>

      <Link
        href={`${ROUTES.LOGIN}?referrer=${referrer}`}
        onClick={() => genericEventHandler(GlobalEvents.AUTH__CLICK_SIGN_IN)}
      >
        Return to Login
      </Link>
    </div>
  );
};
